import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFanforgeApi } from '@hotpot-arcade/fanforge-api-client';

export const useIntentRedirect = () => {
  const navigate = useNavigate();
  const { client } = useFanforgeApi();
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    const fetchIntent = async () => {
      const response = await client.intent.$get();

      if (response.ok) {
        const gameId = (await response.json()).gameId;

        if (!gameId) return;

        if (!hasRedirected) navigate(`/${gameId}`);

        setHasRedirected(true);
      }
    };

    fetchIntent();
  }, [navigate, client, hasRedirected]);
};
